module.exports = __webpack_public_path__ + "img/5-things-contractors-can-do-to-improve-client-communication.9489e115.jpg";